const STORE_FRONT_ID_IN_SHOP = "STORE_FRONT_ID_IN_SHOP"

export const getLocalStorageStoreFrontIdInShop = () => localStorage.getItem(STORE_FRONT_ID_IN_SHOP) as string

export const setLocalStorageStoreFrontIdInShop = (storeId: string) =>
  localStorage.setItem(STORE_FRONT_ID_IN_SHOP, storeId)

export const removeLocalStorageStoreFrontIdInShop = () => localStorage.removeItem(STORE_FRONT_ID_IN_SHOP)
